export default __webpack_public_path__ + "assets/cb-deploy-iss.8124aa54.gif";